
/* injects from baggage-loader */

'use strict';

import authenticationTemplate from '!!file-loader?name=templates/[name].[ext]!./authentication.html';

/**
 * Function that register the all routes for the authentication module.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @param {any} routerHelper
 * @param {any} navigationConstant
 */
function routeConfig($q, $ocLazyLoad, routerHelper, navigationConstant) {
	'ngInject';

	/**
	 * Route definition of the authentication page.
	 */
	const indexNav = 2;
	const authenticationRoute = {
		state: navigationConstant.RESOURCES[indexNav].STATE,
		config: {
			url: navigationConstant.RESOURCES[indexNav].URL,
			templateUrl: authenticationTemplate,
			controller: 'AuthenticationController',
			controllerAs: 'authvm',
			resolve: {
				authentication: authenticationLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].CODE,
				login: false,
				pageTitle: navigationConstant.RESOURCES[indexNav].NAME,
				submenu: false
			},
		}
	}

	const authenticationDefaultRoute = {
		state: 'authenticationDefault',
		config: {
			url: '/',
			templateUrl: authenticationTemplate,
			controller: 'AuthenticationController',
			controllerAs: 'authvm',
			resolve: {
				authentication: authenticationLazyLoading
			},
			data: {
				code: navigationConstant.RESOURCES[indexNav].CODE,
				login: false,
				pageTitle: navigationConstant.RESOURCES[indexNav].NAME,
				submenu: false
			},
		}
	}

	routerHelper.configureStates([authenticationDefaultRoute, authenticationRoute]);
}

/**
 * Function for the lazyLoading configuration in the authentication route.
 *
 * @param {any} $q
 * @param {any} $ocLazyLoad
 * @returns
 */
function authenticationLazyLoading($q, $ocLazyLoad) {
	'ngInject';

	const deferred = $q.defer();

	require.ensure([], require => {
		const authenticationModule = require('./authentication.module');

		$ocLazyLoad.load({
			name: authenticationModule.default.name,
		});

		deferred.resolve(authenticationModule.default.controller);
	});

	return deferred.promise;
}

export default angular
	.module('authentication.routes', [])
	.run(routeConfig);



// WEBPACK FOOTER //
// ./src/app/public/authentication/authentication.routes.js